import React, { useEffect } from "react";

const LINES = [
  "JAKOB-OS (C) 2004-2026",
  "CPU: JAKOB Core i9-9000K  Cache: React 19",
  "Memory Test: 640K CONVENTIONAL + CLOUD OK",
  "Detecting Drives... C:\\PORTFOLIO  D:\\PROJECTS  OK",
  "Loading JAKOBOS...",
];

const BootScreen = ({ onDone, honorReducedMotion = true }) => {
  useEffect(() => {
    const reduced = honorReducedMotion && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const id = window.setTimeout(onDone, reduced ? 0 : 1600);
    return () => window.clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <button
      type="button"
      onClick={onDone}
      aria-label="Skip boot sequence"
      className="fixed inset-0 z-[9999] flex w-full cursor-pointer flex-col justify-center bg-black px-6 py-10 text-left font-mono98 text-sm text-[#c0c0c0] sm:px-16 sm:text-base"
    >
      {LINES.map((line) => (
        <p key={line} className="leading-7">{line}</p>
      ))}
      <div className="mt-6 h-4 w-full max-w-md border border-[#c0c0c0]">
        <div className="boot-bar-force h-full bg-[#c0c0c0]" style={{ animation: "boot-progress 1.4s linear forwards" }} />
      </div>
      <p className="mt-3 text-xs text-[#808080]">(click anywhere to skip)</p>
    </button>
  );
};

export default BootScreen;
